import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAutomatedReports, removeAutomatedReport } from '../../../redux/actions/searchAlertsAction';
import AutomatedReportsTable from './AutomatedReportsTable';
import DeleteModal from '../../common/Modals/DeleteModal';

export class AutomatedReports extends Component {
  static displayName = 'AutomatedReports';

  constructor(props) {
    super(props);

    this.state = {
      showPopup: false,
      onConfirmModal: () => {},
    };
  }

  componentDidMount() {
    this.props.getAlerts();
  }

  onRemoveButtonClick = (id) => {
    this.setState({
      showPopup: true,
      onConfirmModal: () => {
        this.props.removeAlert({ id });
        this.onCloseModal();
      },
    });
  };

  onCloseModal = () => {
    this.setState({
      showPopup: false,
      onConfirmModal: () => {},
    });
  };

  render() {
    const { alerts, getAlerts, isLoading } = this.props;

    return (
      <section>
        <h2 id="realtime-alerts-top" style={{ marginTop: '32px' }}>Automated Reports</h2>
        <p>
          Receive reports (email & CSV) of bankruptcy cases matching specific criteria that you set.
        </p>

        <div style={{ textAlign: 'right' }}>
          <a href="/filings/search-bankruptcy-reports" className="form-submit">Add New Report</a>
        </div>

        <AutomatedReportsTable {...{
          alerts,
          isLoading,
          onRemoveButtonClick: this.onRemoveButtonClick,
        }} />

        <div style={{ textAlign: 'right' }}>
          <small>
            <a
              href="#"
              onClick={(e) => { e.preventDefault(); getAlerts(); }}
            >
              Refresh
            </a>
          </small>
        </div>

        <DeleteModal
          show={this.state.showPopup}
          title="Remove Alert"
          onClose={this.onCloseModal}
          onConfirm={this.state.onConfirmModal}
        >
          Are you sure you wish to remove this alert?
        </DeleteModal>
      </section>
    );
  }
}

AutomatedReports.propTypes = {
  alerts: PropTypes.array,
  isLoading: PropTypes.bool,
  getAlerts: PropTypes.func,
  removeAlert: PropTypes.func,
};

AutomatedReports.defaultProps = {
  alerts: [],
  isLoading: false,
  getAlerts: () => {},
  removeAlert: () => {},
};

const mapStateToProps = state => ({
  alerts: state.getIn(['automatedReports', 'alerts']).toJS(),
  isLoading: state.getIn(['automatedReports', 'isLoading']),
});

const mapDispatchToProps = {
  getAlerts: getAutomatedReports,
  removeAlert: removeAutomatedReport,
};

export default connect(mapStateToProps, mapDispatchToProps)(AutomatedReports);



// WEBPACK FOOTER //
// ./src/components/searchAlerts/AutomatedReports/AutomatedReports.jsx